import { setLocation } from 'www/utils'

export default () => {
  const selectElement = $('.b-tab-navigation__select_js_addresses')

  // eslint-disable-next-line func-names
  selectElement.on('change', function () {
    setLocation($(this).val())
  })
}
